module.exports = __webpack_public_path__ + "img/浙江元通二手车有限公司.baf77872.png";